import React, { createContext, useContext, useReducer } from 'react';
export const TimeMangementStateContext = createContext();
export const TimeMangementStateProvider = ({ reducer, initialState, children }) => (
  <TimeMangementStateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </TimeMangementStateContext.Provider>
);
export const useTimeMangementState = () => useContext(TimeMangementStateContext);
